import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AUTH_API } from '@dges/modules/auth/domain';
import * as AuthActions from './auth.actions';
import { SNACKBAR_FACADE } from '@dges/modules/snackbar';
import { Router } from '@angular/router';
import { FirebaseError } from 'firebase/app';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private authApi = inject(AUTH_API);
  private snackBar = inject(SNACKBAR_FACADE);
  private router = inject(Router);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.login),
      switchMap((action) =>
        this.authApi.login(action.email, action.password).pipe(
          map((user) => AuthActions.loginSuccess({ user })),
          catchError((error: FirebaseError) => {
            this.snackBar.queueSnackBar(error.message);
            return of(AuthActions.loginFail({ error }));
          }),
        ),
      ),
    ),
  );

  loginWithGoogle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loginWithGoogle),
      switchMap(() =>
        this.authApi.loginWithGoogle().pipe(
          map((user) => AuthActions.loginSuccess({ user })),
          catchError((error: FirebaseError) => {
            this.snackBar.queueSnackBar(error.message);
            return of(AuthActions.loginFail({ error }));
          }),
        ),
      ),
    ),
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      switchMap(() =>
        this.authApi.logout().pipe(
          map(() => AuthActions.redirectOnLogin()),
          catchError((error: FirebaseError) => {
            this.snackBar.queueSnackBar(error.message);
            return of(AuthActions.logoutFail({ error }));
          }),
        ),
      ),
    ),
  );

  laodUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loadUser),
      switchMap(() =>
        this.authApi.user$.pipe(
          map((user) =>
            AuthActions.loadUserSuccess({
              user: user ?? { uid: undefined, email: '', displayName: '' },
            }),
          ),
          catchError((error: FirebaseError) =>
            of(AuthActions.loginFail({ error })),
          ),
        ),
      ),
    ),
  );
}
